<template>
  <a :href="sitimmoUser.linkedinUrlConnexion">
    <img :src="require(`@/assets/signin-button-linkedin.png`)" alt="" class="slider-bv"/>
  </a>
</template>

<script>
export default {
  name: 'linkedinLogin',
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  }
}
</script>

<style>
</style>
